export class Hour {
  open: string;
  close: string;
  days: string;
  ldJsonFormat: string;
  $key: string;
}



// WEBPACK FOOTER //
// ./src/ng2/app/models/hour.ts